module.exports = __webpack_public_path__ + "cc6a6c5163995f15a57af863e960acc4.pdf";